import { Skeleton } from '@ordo/ui/skeleton'

import { OrdoPageContainer } from '@/components/ordo-page-container'

/**
 * Body-only skeleton — the mealtime buttons, no date heading. Used once the
 * page's real header (title + day chevrons) is already mounted, which is
 * every load after the first: the day stepper must never unmount, or the
 * operator loses the control they just tapped.
 */
export function CafeteriaTodayBodySkeleton() {
  return (
    <div className="mx-auto grid w-full max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="flex min-h-72 flex-col items-start gap-6 rounded-[2rem] border bg-card p-8 shadow-md">
          <div className="flex w-full items-start justify-between gap-4">
            <Skeleton className="h-20 w-20 rounded-2xl" />
            <Skeleton className="h-6 w-24 rounded-full" />
          </div>
          <div className="w-full">
            <Skeleton className="h-8 w-52" />
            <Skeleton className="mt-4 h-10 w-40" />
          </div>
        </div>
      ))}
    </div>
  )
}

/**
 * Cold-load skeleton for the Today dashboard — the header (date heading on
 * the left, the "Print serving sheets" action on the right, closed by the
 * same divider as `OrdoPageHeader`) + the mealtime buttons.
 */
export function CafeteriaTodaySkeleton() {
  return (
    <OrdoPageContainer>
      <div className="mb-6 flex items-center justify-between gap-4 border-b border-border pb-4">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-9 w-44" />
      </div>
      <CafeteriaTodayBodySkeleton />
    </OrdoPageContainer>
  )
}
